import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

interface mutateProps {
  checklistId: string;
  id: string
}

const mutateDeleteQualityChecklistItem = async ({
  checklistId,
  id,
}: mutateProps) => {
  return await axiosAuth.delete(
    `${QUALITY_CHECKLIST_API}/${checklistId}/items/${id}`,
  );
};

const useDeleteQualityChecklistItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteQualityChecklistItem,
    ...queryParams,
  });

export default useDeleteQualityChecklistItemMutation;
